import { Input } from "@headlessui/react";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

export const TextInput = ({ type = "text", value, setValue, ...rest }) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const isPassword = type === "password";

    return (
        <div className="relative w-full">
            <Input
                type={isPassword ? (showPassword ? "text" : type) : type}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="bg-cm-p-surface w-full rounded-lg border-none pt-4 pb-4 pr-12 pl-5 flex justify-center items-center focus:ring-cm-accent-160 text-cm-p-text-primary text-base font-semibold placeholder-cm-p-text-secondary [&::placeholder]:font-normal"
                {...rest}
            />

            {isPassword && (
                <button
                    type="button"
                    onClick={handleTogglePassword}
                    className="absolute right-5 top-1/2 transform -translate-y-1/2 focus-within:outline-cm-accent-160 focus-visible:outline-cm-accent-160 text-cm-p-text-primary"
                >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
            )}
        </div>
    );
};
